import {
	MimaButton,
	MimaInput,
	MimaTagInput,
	IconButton,
	MimaText,
	MimaTextArea,
	Modal,
	PageLoader,
} from '../../components';
import {
	AddEmployeesContainer,
	SpecificEmployeeContainer,
} from '../../containers';
import styles from '../../assets/styles/Employees/Employees.module.scss';
import { Field, FieldArray, Formik } from 'formik';
import { toJS } from 'mobx';
import React from 'react';
import {GrUserWorker} from 'react-icons/gr'
import { employeeStore } from '../../stores';

const FieldInput = ({ field, ...props }) => {
	return <MimaInput {...field} {...props} />;
};

const ViewDepartments = ({
	closeModal,
	loading,
	validationSchema,
	onSubmit,
	createDepartment,
	showCreateDepartment,
	deptDetails,
	showDeptDetails,
	deptNames,
	goBack,
	showCreateUnit,
	createUnit,
	onSubmitUnit,
	unitValidationSchema
}) => {

	const selectedDepartment = employeeStore?.selectedDepartment;

	const deptMembers = employeeStore.employees.filter((x) => {
		return x?.department?.name === selectedDepartment?.name
	})

	return (
		<Modal closeModal={closeModal} goBack={goBack}>
			<>
				<MimaText variant="subtitleBold" mb={3}> Departments </MimaText>
				{!createDepartment && !deptDetails && (
					<>
						<MimaButton
							title="Create Department"
							onClick={showCreateDepartment}
						/>
						<div className={styles.employee__list}>
							{toJS(deptNames).map((dept, i) => (
								<div key={i}>
									<li 
										onClick={() => {
										employeeStore.setSelectedDepartment(dept);
										showDeptDetails();
									}}>
											{dept.name}
									</li>
									<div className={styles.employee__list_line}></div>
								</div>
							))}
						</div>
					</>
				)}
				{createDepartment && (
					<>
						<MimaText
							variant="subtitle"
							align="center"
							color="var(--color-primary)"
							mb={2}
						>
							Create Departments
						</MimaText>
						<Formik
							initialValues={{
								depts: [
									{
										name: '',
										description: '',
									},
								],
							}}
							validationSchema={validationSchema}
							onSubmit={onSubmit}
						>
							{({
								handleChange,
								handleBlur,
								handleSubmit,
								setFieldValue,
								values,
								errors,
								touched,
							}) => (
								<div>
									<FieldArray name="depts">
										{({ push, remove }) => (
											<React.Fragment>
												{values.depts.map((_, i) => (
													<div key={i}>
														<Field
															name={`depts.${i}.name`}
															id={`depts.${i}.name`}
															component={FieldInput}
															type="text"
															placeholder="Department name"
															labelTitle="Name"
														/>
														<Field
															name={`depts.${i}.description`}
															id={`depts.${i}.description`}
															component={FieldInput}
															type="text"
															placeholder="What do they do?"
															labelTitle="Description(optional)"
														/>

														{i !== 0 ? (
															<IconButton
																variant="remove"
																onClick={() => remove(i)}
															/>
														) : (
															''
														)}
													</div>
												))}
												<MimaButton
													title="Add Another Department"
													variant="text"
													type="button"
													onClick={() =>
														push({
															name: '',
															description: '',
														})
													}
												/>
											</React.Fragment>
										)}
									</FieldArray>
									<MimaButton
										title="Continue"
										onClick={handleSubmit}
										type="submit"
										loading={loading}
										mt={2}
									/>
								</div>
							)}
						</Formik>
					</>
				)}
				{deptDetails && !createUnit && (
					<>
						<MimaText variant="bodyBold" width={38} color="var(--color-primary)"  align="center">
							{selectedDepartment.name}
						</MimaText>
						<MimaText variant="small" width={38} align="center" mb={2}>
							{selectedDepartment.description}
						</MimaText>
						{/* <MimaText color="var(--color-primary)" mb={4} variant="small" width={38}  align="center">There are 14 employees and 3 units in this department</MimaText> */}
						
						{/* <MimaButton title="Create A Unit" onClick={showCreateUnit} mb={3} />
						<MimaText variant="bodyBold" width={38} mb={2} align="center">
							Unit Info
						</MimaText> */}
						<div className={styles.unit_group}>
							<div className={styles.unit_card}>
								<GrUserWorker />
								<MimaText variant="smallBold" mt={1} mb={1}>{selectedDepartment.name}</MimaText>
								<MimaText variant="small">{deptMembers.length} members</MimaText>
							</div>
						</div>
						<MimaText variant="bodyBold" width={38} mb={2} mt={4}align="center">
							Department Members
						</MimaText>
						{deptMembers.map((members) => (
							<MimaText width={38} mb={2}  labelTitle={members.jobTitle} >
								{members.user.firstname} {members.user.lastname}
							</MimaText>
						))}

						{/* <div className={styles.employee__list}>
							{toJS(deptNames).map((dept, i) => (
								<div key={i}>
									<li>{dept.name}</li>
								</div>
							))}
						</div> */}
					</>
				)}
				{deptDetails && createUnit && (
					<>
					<MimaText
							variant="subtitle"
							align="center"
							color="var(--color-primary)"
							mb={2}
						>
							Create units
						</MimaText>
						<Formik
							initialValues={{
								units: [
									{
										name: '',
										description: '',
									},
								],
							}}
							validationSchema={unitValidationSchema}
							onSubmit={onSubmitUnit}
						>
							{({
								handleChange,
								handleBlur,
								handleSubmit,
								setFieldValue,
								values,
								errors,
								touched,
							}) => (
								<div>
									<FieldArray name="units">
										{({ push, remove }) => (
											<React.Fragment>
												{values.units.map((_, i) => (
													<div key={i}>
														<Field
															name={`units.${i}.name`}
															id={`units.${i}.name`}
															component={FieldInput}
															type="text"
															placeholder="Unit name"
															labelTitle="Name"
														/>
														<Field
															name={`units.${i}.description`}
															id={`units.${i}.description`}
															component={FieldInput}
															type="text"
															placeholder="Unit Description"
															labelTitle="Description(optional)"
														/>

														{i !== 0 ? (
															<IconButton
																variant="remove"
																onClick={() => remove(i)}
															/>
														) : (
															''
														)}
													</div>
												))}
												<MimaButton
													title="Add Another Unit"
													variant="text"
													type="button"
													onClick={() =>
														push({
															name: '',
															description: '',
														})
													}
												/>
											</React.Fragment>
										)}
									</FieldArray>
									<MimaButton
										title="Continue"
										onClick={handleSubmit}
										type="submit"
										loading={loading}
										mt={2}
									/>
								</div>
							)}
						</Formik>
					</>
				)}
			</>
		</Modal>
	);
};

export default ViewDepartments;
